import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchGiphy } from './client';
import type { GiphyPage } from './models';

// Empty query -> trending; non-empty -> search. One hook covers both.
export function useGiphyGifs(query: string) {
  const q = query.trim();
  return useInfiniteQuery<GiphyPage>({
    queryKey: ['giphy', q],
    queryFn: ({ pageParam, signal }) =>
      fetchGiphy({ q: q || undefined, offset: pageParam as number, signal }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      // Error/empty responses may omit pagination — no further pages then.
      const p = lastPage?.pagination;
      if (!p) return undefined;
      const next = p.offset + p.count;
      return next < p.totalCount ? next : undefined;
    },
    staleTime: 5 * 60 * 1000,
  });
}
